import { t } from '../../localization';
import formatPrice from './format-price';
import configStorage from '../../configuration/config-storage';

const getCaptions = ({
  searchString,
  captionsOverrides,
  isSpecialOfferAvailable,
  discount: discountAmount,
  currency,
  isMdBreakpoint,
}) => {
  const { locale = 'en' } = configStorage.get();
  let description;

  if (captionsOverrides.description) {
    // eslint-disable-next-line prefer-destructuring
    description = captionsOverrides.description;
  }

  if (isSpecialOfferAvailable) {
    const discount = discountAmount ? formatPrice(discountAmount, currency, locale) : 'X';
    description = isMdBreakpoint
      ? t(
          'Get up to {discount} off your first year’s domain when you choose an annual website plan',
          {
            discount,
          }
        )
      : t('Get {discount} off your domain with annual plans', { discount });
  }

  return {
    title: captionsOverrides.title || t('Find Your Perfect Domain'),
    description,
    tabs: {
      domainsTitle: t('Buy new domain'),
      purchasedDomainsTitle: t('Use existing domain'),
    },
    search: {
      button: t('Search'),
      placeholder: t('Find your perfect domain'),
      errorMessage: t('Use only letters and numbers for domain name'),
    },
    errorMessage: t(
      'Sorry, <mark>{searchString}</mark> domain is already taken. But you may choose another domain',
      { searchString }
    ),
    backButton: captionsOverrides.closeButton || t('Back to editor'),
    nextButton: captionsOverrides.nextButton || t('Not now'),
    free: t('Free'),
    temporary: t('Temporary'),
    premium: t('Premium'),
  };
};

export default getCaptions;
